import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from '../account/useAccount';

const NO_APPLICATIONS = [];

const useEmployeeHiring = ({ employeeId, enabled = true }) => {
  const { accountId } = useAccount();

  const storeKey = ['employeeHiring', accountId, employeeId];
  const { isLoading, data } = useQuery(storeKey, () => api.fetchEmployeeHiring({ accountId, employeeId }), {
    enabled: enabled && !!employeeId,
    select: (response) => response?.data ?? []
  });

  return { isLoading, applications: data ?? NO_APPLICATIONS };
};

export default useEmployeeHiring;
